import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTasks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4531 14.4745V12.0705C10.4531 11.6415 10.6235 11.2301 10.9268 10.9268C11.2301 10.6235 11.6415 10.4531 12.0705 10.4531H14.4745M5.63699 7.87207L7.14072 9.37581L10.363 6.15351M13.9533 11.8434L11.8434 13.9539C11.67 14.1271 11.4642 14.2645 11.2378 14.3582C11.0113 14.4519 10.7686 14.5001 10.5235 14.5H3.36603C2.87113 14.5 2.3965 14.3034 2.04655 13.9535C1.6966 13.6035 1.5 13.1289 1.5 12.634V3.36603C1.5 2.87113 1.6966 2.3965 2.04655 2.04655C2.3965 1.6966 2.87113 1.5 3.36603 1.5H12.634C13.1289 1.5 13.6035 1.6966 13.9535 2.04655C14.3034 2.3965 14.5 2.87113 14.5 3.36603V10.5241C14.4999 11.019 14.3032 11.4935 13.9533 11.8434Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTasks;
